import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextEditor from "../../../../components/TextEditor/TextEditor";

export default function MessageOuvertureVente({ setMailContent }) {
	return (
		<Box>
			<TextEditor
				content=""
				onChange={(html) => setMailContent(html)}
			/>
			<br />
			<Button
				variant="contained"
				type="submit"
				fullWidth
			>
				Partager la vente
			</Button>
		</Box>
	);
}

/*
 */
